import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CryptoWalletInterested, UserInterests } from '../entities/user-interests.entity';

@Injectable({
  providedIn: 'root',
})
export class DepotInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #userSettingsEndpoint = `${environment.apihost}/api/usersettings`;

  public getUserInterests(): Observable<UserInterests> {
    return this.#http.get<UserInterests>(`${this.#userSettingsEndpoint}/interests`);
  }

  public dismissSavingsPlanTeaser(): Observable<UserInterests> {
    return this.#http.post<UserInterests>(`${this.#userSettingsEndpoint}/interests`, {
      savingplan_interested: false,
    });
  }

  public setCryptoWalletInterested(interested: boolean): Observable<CryptoWalletInterested> {
    return this.#http.post<CryptoWalletInterested>(`${this.#userSettingsEndpoint}/cryptowalletinterested`, {
      crypto_wallet_interested: interested,
    });
  }

  public activateDirectDebit() {
    return this.#http.post<void>(`${environment.apihost}/api/savingsplan/directdebit`, { useDirectDebit: true });
  }
}
